import { useGetTemplateVersions } from '../api/templates/hooks';

export const useTemplateHistory = (templateId: string) =>
  useGetTemplateVersions({ pathParams: { templateId } });
